import React, {Component} from "react";
import { inject, observer } from "mobx-react";
import { reaction, observable, toJS } from "mobx";
import DataWrapper from '../../principal/containers/DataWrapper';
import {TabelaFluxo} from "../../comum/components/TabelaFluxo";
import SolicitacoesPendentesStore from "../stores/SolicitacoesPendentesStore";
import {
    motivoContratacaoFormatter, slaFormatter, ordenarData, ordenarSLA,
    mudarDiasAlerta, nullable, formatarNomeProduto
} from "../../../utils/formatar";
import {sortAlphaNum} from "../../../utils/ordenar";
import ParametrosGeraisStore from "../../administracao/stores/ParametrosGeraisStore";

@inject("store")
@DataWrapper
@observer
export class SolicitacoesPendentes extends Component {
    constructor(props) {
        super(props);
        this.appStore                   = this.props.store.appStore;
        this.tituloPaginaStore          = this.props.store.tituloPaginaStore;
        this.modalStore                = this.props.store.modalStore;
        this.loginStore                = this.props.store.loginStore;
        /* Selecionar Controller */
        this.controller                 = new SolicitacoesPendentesStore();
        this.parametrosGeraisStore = new ParametrosGeraisStore();
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Solicitações");

        this.controller.carregarLista();
        this.parametrosGeraisStore.carregarLista();

        this.tituloPaginaStore.setBotoesMobile([
            {
                label: "Ordenar",
                icone: "sort",
                acao: () => this.modalStore.toggleModal('ordenar')
            }
        ]);
    }

    produtoFormat = (cell, row) => {
        return cell && row.codigoProduto ? cell + " (" + row.codigoProduto +")" : cell ? cell : null;
    }

    recarregarTabela = () => {
        this.controller.carregarLista();
        this.parametrosGeraisStore.carregarLista();
    }

    obterTituloMobile = (objeto) => {
        // return  "#" + objeto.idSolicitacaoExibicao + " - " + objeto.cargo + " para " + objeto.nomeProduto;
        return  (objeto.idSolicitacaoExibicao != null ? "#" + objeto.idSolicitacaoExibicao : "") + (objeto.cargo != null ? " - " + objeto.cargo : "") + (objeto.nomeProduto != null ? " para " + objeto.nomeProduto : "");
    };

    obterConteudoMobile = (objeto) => {
        return (
            <div>
                { "SLA: "}<div  style={{display: "inline-block"}}>{slaFormatter(objeto.sla, objeto)}</div><br/>
                { "Fluxo: " + nullable(this.controller.fluxoFormatter(objeto.nomeFluxo))}<br/>
                { "Tarefa: " + nullable(objeto.nomeTarefa)}<br/>
                { "Responsável: " + nullable(objeto.nomeResponsavel)}<br/>
                { "Prazo: " + nullable(objeto.prazo)}<br/>
                { "Solicitante: " + nullable(objeto.nomeSolicitante)}<br/>
                { "Gestor: " + nullable(objeto.nomeGestor)}<br/>
                { "Motivo de contratação: " + nullable(motivoContratacaoFormatter(objeto.motivoContratacao))}<br/>
                { "Justificativa: " + nullable(objeto.justificativa)}<br/>
                { "Data de início: " + nullable(objeto.dataInicio)}<br/>
                { "Data de término: " + nullable(objeto.dataFim)}
            </div>
        )
    };

    render() {
        mudarDiasAlerta(this.parametrosGeraisStore.parametros.slaGrlTmpAvaliarResponder)

        const colunas = [
            {
                field: "idSolicitacaoExibicao",
                label: "#",
                funcaoOrdenacao: sortAlphaNum.bind("idSolicitacaoExibicao"),
            },{
                field: "nomeFluxo",
                label: "Fluxo",
                dataFormat: this.controller.fluxoFormatter,
            },{
                field: "nomeTarefa",
                label: "Tarefa",
            },{
                field: "nomeResponsavel",
                label: "Responsável",
            },{
                field: "prazo",
                label: "Prazo",
                funcaoOrdenacao: ordenarData.bind("prazo"),
            },{
                field: "sla",
                label: "SLA",
                dataFormat: slaFormatter,
                funcaoOrdenacao: ordenarSLA.bind("prazo"),
            },{
                field: "nomeSolicitante",
                label: "Solicitante",
            },{
                field: "nomeGestor",
                label: "Gestor"
            },{
                field: "cargo",
                label: "Cargo"
            },{
                field: "motivoContratacao",
                label: "Motivo de contratação",
                dataFormat: motivoContratacaoFormatter,
            },{
                field: "justificativa",
                label: "Justificativa"
            },{
                field: "nomeProduto",
                label: "Projeto/centro de resultado/finalidade",
                dataFormat: formatarNomeProduto
            },{
                field: "dataInicio",
                label: "Data de início",
                funcaoOrdenacao: ordenarData.bind("dataInicio")
            },{
                field: "dataFim",
                label: "Data de término",
                funcaoOrdenacao: ordenarData.bind("dataFim")
            }
        ];

        return (
            <div>
                <div className="form-wrapper">
                    <div className={this.appStore.width > 768 ? "content-panel" : ""}>
                        <TabelaFluxo
                            keyField={"idSolicitacaoBpm"}
                            nomeFluxo={'Solicitação'}
                            onChange={(value) => this.controller.setLista(value)}
                            listaItens={toJS(this.controller.solicitacoesPendentesLista)}
                            colunas={colunas}
                            parametroVisualizar={'idSolicitacaoBpm'}
                            parametroClonar={'idSolicitacao'}
                            temBusca={true}
                            //TODO: novas acoes devem ser criadas em TabelaFluxo
                            acoesItens={["visualizar"]}
                            acoesMultiplas={(!_.get(this.loginStore.usuarioLogado, "matricula") || this.loginStore.isPerfilEttLogado) ? [] : ["delegar", "aprovar"] } //["delegar", "aprovar"]
                            tituloMobile={(row) => this.obterTituloMobile(row)}
                            conteudoMobile={(row) => this.obterConteudoMobile(row)}
                            loading={this.controller.loading}
                            controller={this.controller}
                            recarregar={this.recarregarTabela}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

